import React, { useState } from "react";

// Components
import ListAlamat from "./ListAlamat";

// react-router-dom
import { useHistory } from "react-router-dom";

// Material-UI
import { Button } from "@material-ui/core";

// useStyles
import useStyles from "./styles";

//
import AlamatDialog from "./AlamatDialog";
// import { setData } from "../../utils";

// React-Helmet
// import { Helmet } from "react-helmet";
import Header from "../../../components/molecules/Header";
import Gap from "../../../components/atoms/Gap";
import { useData } from "../../../components/firebase/DataProvider";

export default function Alamat() {
  const history = useHistory();

  const classes = useStyles();

  const { alamat } = useData();
  // console.log(alamat);
  // const { subdomain } = useFirebase();

  const [dialog, setDialog] = useState({
    open: false,
    action: "",
    data: {},
  });

  // useEffect(() => {
  //   const setNewAlamatId = () => {
  //     const find = alamat?.find((item) => item.id === alamatId);

  //     if (!find && alamat?.length === 1) {
  //       setData("alamat_id", alamat?.[0]?.id);
  //       setAlamatId(alamat?.[0]?.id);
  //     }
  //   };

  //   setNewAlamatId();
  // }, [alamat, alamatId, setAlamatId]);

  // const toko = `Toko ${
  //   subdomain.charAt(0).toUpperCase() + subdomain.slice(1)
  // } - Daftar Alamat`;

  return (
    <>
      <div className={classes.root}>
        <Header
          type="with-title"
          title="Daftar Alamat"
          onClick={() => history.goBack()}
        />
        <div className={classes.contentWrapper}>
          <Button
            variant="outlined"
            color="primary"
            fullWidth
            className={classes.btn}
            onClick={() => {
              setDialog({
                open: true,
                action: "add",
              });
            }}
          >
            Tambah Alamat
          </Button>
          {alamat?.length > 0 ? (
            alamat?.map((item) => {
              return (
                <ListAlamat
                  key={item.id}
                  data={item}
                  length={alamat.length}
                  handleEdit={() => {
                    setDialog({
                      open: true,
                      action: "edit",
                      data: item,
                    });
                  }}
                />
              );
            })
          ) : (
            <div className={classes.empty}>
              <p>Tidak ada data</p>
            </div>
          )}
        </div>
        <AlamatDialog
          open={dialog.open}
          action={dialog.action}
          data={dialog.data}
          handleClose={() => {
            setDialog({
              open: false,
              action: "",
            });
          }}
        />
      </div>
    </>
  );
}
